/**
 * @module Support
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

/**
 * Shared Module
 * Shared Module that is used to provide shared components across the application
 * @access public
 */
@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [],
  exports: [],
  providers: [
    CurrencyPipe,
    DatePipe
  ]
})
export class SharedModule {}
